module.exports = __webpack_public_path__ + "media/טבעת.6d01175e.mp3";